export const FIX_CONTACT_MISSING_PRIMARY_TITLE = 'Primary client is missing';

export const FIX_CONTACT_MISSING_PRIMARY_DESCRIPTION =
  "This household doesn't have an editable primary client yet. To add one, re-upload your spreadsheet with the client's name, email, and phone number.";

export const FIX_CONTACT_OPEN_BULK_UPLOAD_LABEL = 'Open Import book';

export const FIX_CONTACT_HOUSEHOLD_NOT_FOUND_DESCRIPTION =
  'This household is no longer available. Close and refresh the page.';
